import Progress, { Line, Circle } from './src/'

export {
  Line,
  Circle,
}

export default Progress



// WEBPACK FOOTER //
// ./components/vc-progress/index.js